import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-100/50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl text-primary-500 whitespace-nowrap cursor-pointer">
              动漫精选
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              汇聚高质量成人动漫作品推荐、类型解析与观看指南，助你快速发现优质成人动漫资源。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">首页推荐</Link></li>
              <li><Link to="/category/story" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">分类浏览</Link></li>
              <li><a href="/#ranking" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">排行榜</a></li>
              <li><a href="/#articles" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">最新文章</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/story" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">剧情向</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">奇幻冒险</Link></li>
              <li><Link to="/category/scifi" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">科幻未来</Link></li>
              <li><Link to="/category/mystery" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">悬疑推理</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">用户评价</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">联系方式</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 成人动漫精选推荐. 本站为资源导航网站，所有内容仅供学习参考。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}